import { render } from "./TasksElement.vue?vue&type=template&id=fbeb5cd8&scoped=true&ts=true"
import script from "./TasksElement.vue?vue&type=script&lang=ts"
export * from "./TasksElement.vue?vue&type=script&lang=ts"

import "./TasksElement.vue?vue&type=style&index=0&id=fbeb5cd8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbeb5cd8"]])

export default __exports__